import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadItemComponent } from './file-upload-item/file-upload-item.component';
import { FileUploadComponent } from './file-upload.component';

import { ReactiveFormsModule } from '@angular/forms';
import { FormControlBaseModule } from '../../component-base/form-control-base.module';
import { LunaCommonModule } from '../../../common/common.module';
import { PipesModule } from "../../../common/pipes/pipes.module";

@NgModule({
  imports: [
      CommonModule,
      ReactiveFormsModule,
      FormControlBaseModule,
      LunaCommonModule,
      PipesModule
    ],
    providers: [

    ],
    declarations: [
        FileUploadItemComponent,
        FileUploadComponent
    ],
    exports: [
        FileUploadComponent
    ]
})
export class FileUploadModule { }
